import { render } from "./CardTypographyControls.vue?vue&type=template&id=0fcf42c4&scoped=true"
import script from "./CardTypographyControls.vue?vue&type=script&lang=js"
export * from "./CardTypographyControls.vue?vue&type=script&lang=js"

import "./CardTypographyControls.vue?vue&type=style&index=0&id=0fcf42c4&scoped=true&lang=css"

import exportComponent from "/Volumes/works/main/ProfileSuite/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fcf42c4"]])

export default __exports__